const initialState = 1;

const searchDetailsReferenceDocumentsPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_DETAILS_REFERENCE_DOCUMENTS_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                        return 1;                  
            default:
                  break;
      }
      return state;
};
export default searchDetailsReferenceDocumentsPaginationReducer;